import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { routerTransition } from '../../../../util/animations';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { LoginService } from 'src/app/services/login.service';
import { SwalComponent } from '@sweetalert2/ngx-sweetalert2';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { NcmService } from 'src/app/services/ncm.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'cp-list',
  templateUrl: './ncm.list.component.html',
  styles: [],
  animations: [routerTransition],
})
export class NcmListComponent
  implements OnInit, AfterViewInit {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private loginService: LoginService,
    private ncmService: NcmService
  ) {}

  dtOptions:  DataTables.Settings = {};
  title: string;
  description:string;
  currentPage: number = 0;
  currentPageSize:number = 10;
  filterIsAtivo: boolean = true;
  currentRecord: number;
  search: string = '';
  msgErroServer: string = "Ops, aconteceu algum imprevisto no servidor. ";

  @ViewChild('deleteConfirmationMessage')
  public readonly deleteConfirmationMessage!: SwalComponent;
  @ViewChild('errorMessage')
  public readonly errorMessage!: SwalComponent;
  @ViewChild('ativarDesativarConfirmationMessage')
  public readonly ativarDesativarConfirmationMessage!: SwalComponent;

  ngAfterViewInit(): void {}

  ngOnInit() {
    window.functions = window.functions || {};
    window.functions.editEntity = this.editEntity.bind(this);
    window.functions.deleteEntity = this.deleteEntity.bind(this);
    window.functions.ativarDesativarEntity = this.ativarDesativarEntity.bind(this);

    var self = this;
    this.dtOptions = {
      processing:true,
      serverSide:true,
      ajax: {
       // url: 'https://kironwebapi.azurewebsites.net/ipi',
        url: environment.apiUri + '/ipi',
        data: function (d) {
          var queryData = {
            page: d['start'] / d['length'] + 1,
            pageSize:d['length'],
            status: self.filterIsAtivo ? 'A' : 'I',
            ncm: self.search
          }
          self.currentPage = queryData.page;
          self.currentPageSize = queryData.pageSize;
          return queryData;
        },
        dataSrc : function(json) : any {
          json.recordsTotal = json.count;
          json.recordsFiltered = json.count
          return json.data;
        },
        async: true,
        error: function (xhr, error, code)
          {
            if((xhr.status == 400) || (xhr.status == 401)) {
              self.loginService.tokenExpired();
            }
          },
        headers: { 'x-access-token': this.loginService.getToken() }
      },
      columns : [
        { "data": "ncm" },
        { "data": "cest" },
        { "data": "pIpi" },
        { "data": "pBC" },
        { "data": "pIBPTNac", render: $.fn.dataTable.render.number( '.', ',', 2, ' ' )},
        { "data": "pIBPTImp", render: $.fn.dataTable.render.number( '.', ',', 2, ' ' )},
        {
          "data": "id",
          render: (data, type, full) => {
            return `<div class='text-center'><a href='javascript:void(0);' onclick=\"functions.editEntity('${data}')\" class='btn btn-primary btn-sm btn-icon rounded-circle' title='Editar registro'><i class='fal fa-pen'></i></a>
                    <a href='javascript:void(0);' onclick=\"functions.ativarDesativarEntity('${data}')\" class='btn btn-primary btn-sm btn-icon rounded-circle' title='Ativar/Desativar'><i class='fal fa-check'></i></a>
                    <a href='javascript:void(0);' onclick=\"functions.deleteEntity('${data}')\" class='btn btn-danger btn-sm btn-icon rounded-circle' title='Deletar registro'><i class='fal fa-times'></i></a></div>`;
          }
        }
    ],
      /* render dynamic buttons */
    };

    //Exibe tela de editar no evento onclick na tabela
    // $('#tableList').on( 'click', 'tr', function () {
    //   //alert($("tr").find("td:not(:eq(5)"));
    //     var id = $('#tableList').DataTable().cell( this, 5 ).data();
    //     self.editEntity( id );
    // } );

   
    this.title = 'NCM';
    this.description = 'Lista de NCM ativos e inativos'
}

searchLista() {
   $('#tableList').DataTable().ajax.reload();
}

ngOnDestroy() {
  window.functions = null;
}

changeAtivoFilter(data:boolean) {
  this.filterIsAtivo = data;
  $('#tableList').DataTable().ajax.reload();
}

new() {
   this.router.navigate(['/cadastros/ncm/edit'])
}

editEntity(data) {
    this.router.navigate(['/cadastros/ncm/edit', data])
}

deleteEntity(data) {
  this.currentRecord = data;
  this.deleteConfirmationMessage.fire();
}

confirmDelete() {
  this.ncmService.delete(this.currentRecord).subscribe( () => {
    $('#tableList').DataTable().ajax.reload();
    this.currentRecord = -1;
  }, error => {
    Swal.fire({
      title:  "Erro!",
      text: error.error.message,
      icon: 'error'
  });
   this.currentRecord = -1;
  });
}

handleDenial() {
};


ativarDesativarEntity(data) {
  var msgAtivo: string = this.filterIsAtivo ? 'desativar' : 'ativar';
  this.currentRecord = data;
  Swal.fire({
    title:  "",
    text: 'Tem certeza que deseja ' + msgAtivo + ' este cadastro?',
    icon: "question",
    showDenyButton: true,
    showConfirmButton:true,
    denyButtonText:"Cancelar",
    confirmButtonText:"Confirmar",
    }).then((result) => {
       if (result.value) { 
          this.confirmAtivarDesativar();
       }
   });
  this.ativarDesativarConfirmationMessage.fire();
}

confirmAtivarDesativar() {
  var isAtivo: string = this.filterIsAtivo ? 'N' : 'S';

  this.ncmService.getById(this.currentRecord).subscribe( response=> {
    response.data.isAtivo = isAtivo;
    this.ncmService.update(response.data).subscribe( response=> {
         $('#tableList').DataTable().ajax.reload();
    } , error => {
      Swal.fire({
        title:  "Erro!",
        text: this.msgErroServer + error.error.message,
        icon: 'error'
    });
    this.currentRecord = -1;
  });
     this.currentRecord = -1;
  });}

}

